import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Button,
  Container,
  Stack,
  Typography,
  Modal,
  Box,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Rating,
  FormGroup,
  Checkbox,
} from "@mui/material";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import moment from "moment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ImageViewer from "react-simple-image-viewer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoneIcon from "@mui/icons-material/Done";
import "../../../App.css";
import { useNavigate } from "react-router-dom";
import {
  createBid,
  payment,
  addReview,
  addDispute,
  tipCheckout,
  addEarning,
  addNotification,
  updateLedger,
  completeJob,
  completeStage,
  createChat,
} from "../../../apis";
import { io } from "socket.io-client";
import { green } from "@mui/material/colors";

const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const SelectedBooking = ({ currentRequest, active, ratingHandler }) => {
  const socket = useRef();

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [charity, setCharity] = useState(false);
  const [rating, setRating] = useState(0);
  const [comments, setComments] = useState("");
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [tipAmount, setTipAmount] = useState("");
  const [stageDetailsData, setStageDetailsData] = useState([]);
  const date = moment(currentRequest.request.fromDate)
    .utc()
    .format("MMMM Do, YYYY");

  const user = JSON.parse(localStorage.getItem("user-info"));
  const userID = user?.googleId ? user.googleId : user._id;
  const userEmail = user.email;
  console.log("currentRequest ======> ", currentRequest);
  //   const [offerDetails, setOfferDetails] = useState("");
  //   const [offerType, setOfferType] = useState("project");
  //   const [amount, setAmount] = useState("");
  //   const [stageData, setStageData] = useState([
  //     { stageDetail: "", price: "", dueDate: "" },
  //   ]);
  //   const [userData, setUserData] = useState();
  //   const [currentImage, setCurrentImage] = useState(0);
  //   const [isViewerOpen, setIsViewerOpen] = useState(false);

  //   const date = moment(currentRequest.fromDate).utc().format("MMMM Do, YYYY");
  const handleOpenConfirmation = () => setOpenConfirmation(true);
  const handleCloseConfirmation = () => setOpenConfirmation(false);
  const handleOpenFeedback = () => setOpenFeedback(true);
  const handleCloseFeedback = () => setOpenFeedback(false);
  const handleCloseReport = () => setOpenReport(false);
  const handleOpenReport = () => {
    setOpenReport(true);
    setReason("");
    setDetails("");
    setOpenFeedback(false);
    setOpenConfirmation(false);
  };

  useEffect(() => {
    setStageDetailsData(currentRequest.bid.StageData);
  }, []);
  //   const handleofferType = (e) => setOfferType(e.target.value);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const data = await getUserById(currentRequest.userid);
  //     setUserData(data);
  //   };
  //   fetchData();
  // }, [currentRequest]);

  // useEffect(() => {
  //   console.log(userData);
  // }, [userData]);

  //   const handleChange = (i, e) => {
  //     let newStageData = [...stageData];
  //     newStageData[i][e.target.name] = e.target.value;
  //     setStageData(newStageData);
  //   };

  //   const addStageHandler = () => {
  //     setStageData([...stageData, { stageDetail: "", price: "", dueDate: "" }]);
  //   };

  //   let removeFormFields = (i) => {
  //     let newStageData = [...stageData];
  //     newStageData.splice(i, 1);
  //     setStageData(newStageData);
  //   };

  //   const makeOfferHandler = () => {
  //     let user = JSON.parse(localStorage.getItem("user-info"));
  //     createBid({
  //       userId: currentRequest.userid,
  //       serviceProviderId: user._id,
  //       requestId: currentRequest._id,
  //       offerDetails: offerDetails,
  //       offerType: offerType,
  //       price: amount,
  //       StageData: stageData,
  //       bidStatus: "pending",
  //       bidCreatorName: currentRequest.creatorName,
  //       serviceProviderName: user.fullName,
  //       serviceProviderCountry: user.country,
  //     });
  //     handleClose();
  //   };

  //   const closeImageViewer = () => {
  //     setCurrentImage(0);
  //     setIsViewerOpen(false);
  //   };

  //   const openImageViewer = useCallback((index) => {
  //     setCurrentImage(index);
  //     setIsViewerOpen(true);
  //   }, []);
  const completeJobHandler = async () => {
    if (localStorage.getItem("user-type") == "user") {
      if (currentRequest.bid.offerType == "staged") {
        await completeJob({
          bidId: currentRequest.bid._id,
          requestId: currentRequest.request._id,
        });
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        socket.current = io("https://ammanat-chat-socket.herokuapp.com");
        socket.current.emit("send-notification", {
          receiverId: currentRequest.bid.serviceProviderId,
          to: currentRequest.bid.serviceProviderId,
          message: `Your job has been completed by ${
            user.googleId ? user.name : user.fullName
          }`,
          read: false,
        });
        await addNotification({
          to: currentRequest.bid.serviceProviderId,
          message: `Your job has been completed by ${
            user.googleId ? user.name : user.fullName
          }`,
          read: false,
        });
        handleCloseConfirmation();
        handleOpenFeedback();
      } else {
        const response = await updateLedger({
          id: currentRequest.bid.serviceProviderId,
          amount: currentRequest.bid.price,
          type: "add",
        });

        await completeJob({
          bidId: currentRequest.bid._id,
          requestId: currentRequest.request._id,
        });
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        socket.current = io("https://ammanat-chat-socket.herokuapp.com");
        socket.current.emit("send-notification", {
          receiverId: currentRequest.bid.serviceProviderId,
          to: currentRequest.bid.serviceProviderId,
          message: `Your job has been completed by ${
            user.googleId ? user.name : user.fullName
          }`,
          read: false,
        });
        await addNotification({
          to: currentRequest.bid.serviceProviderId,
          message: `Your job has been completed by ${
            user.googleId ? user.name : user.fullName
          }`,
          read: false,
        });
        handleCloseConfirmation();
        handleOpenFeedback();
        await addEarning({
          serviceProviderId: currentRequest.bid.serviceProviderId,
          earning: currentRequest.bid.price,
          requestId: currentRequest.request._id,
        });
      }
    } else {
      const userInfo = JSON.parse(localStorage.getItem("user-info"));
      socket.current = io("https://ammanat-chat-socket.herokuapp.com");
      socket.current.emit("send-notification", {
        receiverId: currentRequest.bid.userId,
        to: currentRequest.bid.userId,
        message: `Request to complete the job has been submitted by ${userInfo.fullName}`,
        read: false,
      });
      await addNotification({
        to: currentRequest.bid.userId,
        message: `Request to complete the job has been submitted by ${userInfo.fullName}`,
        read: false,
      });
      handleCloseConfirmation();
    }
  };

  const ratingSubmitHandler = async () => {
    await addReview({
      serviceProviderId: currentRequest.bid.serviceProviderId,
      comment: comments,
      rating: rating,
      userId: userID,
      reviewerName: user.googleId ? user.name : user.fullName,
    });
    if (tipAmount != "" && parseInt(tipAmount) > 0 && charity) {
      const response = await tipCheckout({
        name: currentRequest.bid.serviceProviderName,
        price: parseInt(tipAmount) + 1,
        serviceProviderId: currentRequest.bid.serviceProviderId,
      });
      window.location.href = response.data.session;
    }
    if (tipAmount != "" && parseInt(tipAmount) > 0 && charity == false) {
      const response = await tipCheckout({
        name: currentRequest.bid.serviceProviderName,
        price: parseInt(tipAmount),
        serviceProviderId: currentRequest.bid.serviceProviderId,
      });
      window.location.href = response.data.session;
    }
    if (charity) {
      const response = await tipCheckout({
        name: currentRequest.bid.serviceProviderName,
        price: parseInt(1),
        serviceProviderId: currentRequest.bid.serviceProviderId,
      });
      window.location.href = response.data.session;
    }
    handleCloseFeedback();
    ratingHandler();
  };

  const addDisputeHandler = async () => {
    if (reason != "" && details != "") {
      await addDispute({
        reason,
        details,
        amount: currentRequest.bid.price,
        email: userEmail,
        bidId: currentRequest.bid._id,
        requestId: currentRequest.request._id,
      });
      setOpenReport(false);
    }
  };

  const completeStageHandler = async (bidId, stageDetail, price, index) => {
    const data = [...stageDetailsData];
    data[index].status = "complete";
    setStageDetailsData(data);
    await completeStage({
      bidId: bidId,
      stageDetail: stageDetail,
      price: price,
    });
    const response = await updateLedger({
      id: currentRequest.bid.serviceProviderId,
      amount: price,
      type: "add",
    });
    await addEarning({
      serviceProviderId: currentRequest.bid.serviceProviderId,
      earning: price,
      requestId: currentRequest.request._id,
    });
  };

  return (
    <>
      <Modal
        open={openConfirmation}
        onClose={handleCloseConfirmation}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Confirmation
            </Typography>
            <div
              className="crossIconContainer"
              style={{ cursor: "pointer" }}
              onClick={handleCloseConfirmation}
            >
              <span className="crossIcon">X</span>
            </div>
          </Stack>
          <Stack className="mt-16">
            <Typography>Are you sure to mark this job as complete?</Typography>
          </Stack>
          <Stack className="mt-16" direction="row" spacing={4}>
            <Button
              variant="outlined"
              className="default-border default-color"
              style={{ textTransform: "capitalize" }}
              onClick={handleCloseConfirmation}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="primary-button"
              style={{ textTransform: "capitalize" }}
              onClick={completeJobHandler}
            >
              Complete
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={openFeedback}
        // onClose={handleCloseFeedback}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Leave a Feedback
            </Typography>
            <div
              className="crossIconContainer"
              style={{ cursor: "pointer" }}
              onClick={handleCloseFeedback}
            >
              <span className="crossIcon">X</span>
            </div>
          </Stack>

          <Typography className="mb-10 mt-10" style={{ fontWeight: "bold" }}>
            Rate your experience
          </Typography>
          <Rating
            name="simple-controlled"
            value={rating}
            size="large"
            className="default-color"
            onChange={(event, newValue) => {
              setRating(newValue);
            }}
          />
          <Stack className="mt-10">
            <Typography style={{ fontWeight: "bold" }}>Comments</Typography>
            <TextField
              required
              size="small"
              id="outlined-basic"
              variant="outlined"
              className="w-100"
              placeholder="Enter your comments about service provider"
              multiline
              rows={3}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
          </Stack>
          <Stack className="mt-10">
            <Typography style={{ fontWeight: "bold" }}>
              Tip your service provider
            </Typography>
            <TextField
              required
              size="small"
              id="outlined-basic"
              variant="outlined"
              className="w-100"
              placeholder="Enter amount"
              value={tipAmount}
              onChange={(e) => setTipAmount(e.target.value)}
            />
          </Stack>
          <Stack className="mt-10">
            <Typography>
              Amannat will donate 1% of the total Amannat fee to charity which
              is {(currentRequest.bid.price / 100) * 1}.
            </Typography>
          </Stack>

          <Stack className="mt-10">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => {
                      setCharity(e.target.checked);
                    }}
                    checked={charity ? true : false}
                    sx={{
                      "&.Mui-checked": {
                        color: green[500],
                      },
                    }}
                  />
                }
                label="Donate 1£ to charity"
              />
            </FormGroup>
          </Stack>
          <Stack
            className="mt-16"
            direction="row"
            justifyContent="space-between"
          >
            <Button
              variant="outlined"
              className="default-border default-color"
              style={{ textTransform: "capitalize" }}
              onClick={handleCloseFeedback}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="primary-button"
              style={{ textTransform: "capitalize" }}
              onClick={ratingSubmitHandler}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={openReport}
        onClose={handleCloseReport}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Report
            </Typography>
            <div
              className="crossIconContainer"
              style={{ cursor: "pointer" }}
              onClick={handleCloseReport}
            >
              <span className="crossIcon">X</span>
            </div>
          </Stack>
          <Stack spacing={2}>
            <Stack className="mt-13">
              <Typography>Reason</Typography>
              <TextField
                required
                id="outlined-basic"
                variant="outlined"
                className="w-100"
                size="small"
                placeholder="Enter Reason here"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </Stack>
            <Stack className="mt-13">
              <Typography>Details</Typography>
              <TextField
                required
                multiline
                rows={3}
                id="outlined-basic"
                variant="outlined"
                className="w-100"
                size="small"
                placeholder="Enter details here"
                value={details}
                onChange={(e) => setDetails(e.target.value)}
              />
            </Stack>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Button
                style={{ textTransform: "capitalize" }}
                variant="outlined"
                className="default-border default-color"
                onClick={handleCloseReport}
              >
                Cancel
              </Button>
              <Button
                style={{ textTransform: "capitalize" }}
                variant="contained"
                className="primary-button"
                onClick={addDisputeHandler}
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Container style={{ background: "#FAFBFE", height: "100vh" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack>
            <h2>Booking Details</h2>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={4}>
            <ShareOutlinedIcon />
            <FavoriteBorderOutlinedIcon />
          </Stack>
        </Stack>
        <Grid container>
          <Grid item sm={2}>
            <AccountCircleIcon
              style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
            />
          </Grid>
          <Grid item sm={10}>
            <Stack direction="row" justifyContent="space-between">
              <Stack>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  className="mb-5"
                >
                  <Typography style={{ fontWeight: "bold" }}>
                    {currentRequest.bid.serviceProviderName}
                  </Typography>
                  <CheckCircleIcon
                    style={{ height: "15px", width: "15px", color: "#FA8319" }}
                  />
                </Stack>

                {active ? (
                  <span
                    style={{
                      background: "rgba(255, 183, 48, 0.1)",
                      border: "1px solid rgba(250, 131, 25, 1)",
                      borderRadius: "100px",
                      padding: "4px 8px",
                      color: "rgba(250, 131, 25, 1)",
                      width: "100px",
                      textAlign: "center",
                    }}
                  >
                    In Progress
                  </span>
                ) : (
                  <span
                    style={{
                      background: "rgba(39, 245, 110, 0.1)",
                      border: "1px solid rgba(39, 245, 110, 1)",
                      borderRadius: "100px",
                      padding: "4px 8px",
                      color: "rgba(39, 245, 110, 1)",
                      width: "100px",
                      textAlign: "center",
                    }}
                  >
                    Complete
                  </span>
                )}

                <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                  Address
                </Typography>
                <Typography className="mb-10 ammanat-darker-gray">
                  {currentRequest.request.address}
                </Typography>
              </Stack>

              <div
                style={{ background: "white", padding: "20px", width: "200px" }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{ marginBottom: "20px" }}
                >
                  <Typography style={{ color: "#7A7A80" }}>Charges</Typography>
                  <Typography style={{ fontWeight: "bold" }}>
                    £{currentRequest.bid.price}
                  </Typography>
                </Stack>
                {active ? (
                  <Stack spacing={2} alignItems="center">
                    <Button
                      variant="contained"
                      className="primary-button"
                      style={{
                        textTransform: "capitalize",
                        width: "168px",
                      }}
                      onClick={handleOpenConfirmation}
                    >
                      Complete Job
                    </Button>
                    <Button
                      variant="outlined"
                      className="report-button"
                      style={{ textTransform: "capitalize", width: "168px" }}
                      onClick={handleOpenReport}
                    >
                      Report
                    </Button>
                  </Stack>
                ) : (
                  <></>
                )}
              </div>
            </Stack>

            <Stack>
              {currentRequest.request.urgent == true ? (
                <>
                  <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                    Date of Booking
                  </Typography>
                  <span
                    style={{
                      background: "rgba(255, 0, 32, 0.1)",
                      border: "1px solid #EB4335",
                      borderRadius: "100px",
                      padding: "4px 8px",
                      color: "rgba(235, 67, 53, 1)",
                      width: "100px",
                      textAlign: "center",
                    }}
                  >
                    Urgent
                  </span>
                </>
              ) : (
                <>
                  <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                    Date of Booking
                  </Typography>
                  <Typography variant="body1" className="ammanat-darker-gray">
                    {date}
                  </Typography>
                </>
              )}
            </Stack>
            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Title
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {currentRequest.request.title}
              </Typography>
            </Stack>
            <Stack>
              <Typography className="mt-16" style={{ fontWeight: "bold" }}>
                Offer Details
              </Typography>
              <Typography variant="body1" className="ammanat-darker-gray">
                {currentRequest.bid.offerDetails}
              </Typography>
            </Stack>

            {currentRequest.bid.offerType == "staged" ? (
              <>
                {stageDetailsData.map((item, index) => (
                  <Grid container className="mt-12">
                    <Grid item sm={4}>
                      <Typography style={{ fontWeight: "bold" }}>
                        Detail
                      </Typography>
                      <Typography className="ammanat-darker-gray">
                        {item.stageDetail}
                      </Typography>
                    </Grid>
                    <Grid item sm={4}>
                      <Typography style={{ fontWeight: "bold" }}>
                        Price
                      </Typography>
                      <Typography className="ammanat-darker-gray">
                        {item.price}
                      </Typography>
                    </Grid>
                    <Grid item sm={4}>
                      {item.status == "incomplete" ? (
                        <Button
                          variant="contained"
                          className="primary-button"
                          onClick={() =>
                            completeStageHandler(
                              currentRequest.bid._id,
                              item.stageDetail,
                              item.price,
                              index
                            )
                          }
                        >
                          Complete
                        </Button>
                      ) : (
                        <>
                          <DoneIcon />
                        </>
                      )}
                    </Grid>
                  </Grid>
                ))}
              </>
            ) : (
              <></>
            )}

            {/* {currentRequest.images.length ? (
              <Stack>
                <h4>Images and Videos</h4>
                {currentRequest.images.map((item, index) => (
                  <img
                    src={item}
                    style={{
                      height: "120px",
                      width: "120px",
                      cursor: "pointer",
                    }}
                    onClick={() => openImageViewer(index)}
                  />
                ))}
                {isViewerOpen && (
                  <ImageViewer
                    src={currentRequest.images}
                    currentIndex={currentImage}
                    onClose={closeImageViewer}
                    disableScroll={true}
                    backgroundStyle={{
                      backgroundColor: "rgba(0,0,0,0.9)",
                    }}
                    closeOnClickOutside={true}
                  />
                )}
              </Stack>
            ) : (
              <></>
            )} */}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default SelectedBooking;
